import { render, staticRenderFns } from "./newPwd.vue?vue&type=template&id=58e70471&scoped=true&"
import script from "./newPwd.vue?vue&type=script&lang=js&"
export * from "./newPwd.vue?vue&type=script&lang=js&"
import style0 from "./newPwd.vue?vue&type=style&index=0&id=58e70471&lang=scss&scoped=true&"
import style1 from "./newPwd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e70471",
  null
  
)

export default component.exports